<template>
  <div class="wrapper">
    <div class="qr-container" :style="rotateStyle">
      <router-link to="/qrcscanner" class="qr-inner-container">
        <img src="@/assets/qr-code.png" class="qr-code" />
        <label>Click to Scan</label>
      </router-link>
    </div>
    <br />
    <router-link to="/Explore">
      <button class="explore-more">
        <i class="fa fa-search"></i>
        Explore More
      </button>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Landing",
  data() {
    return {
      rotateY: 0,
      counter: 0,
      updateRate: 10,
      limit: 45
    }
  },
  computed: {
    rotateStyle() {
      return { transform: 'translate(-50%, -50%) rotateY(' + this.rotateY + 'deg)' }
    },
  },
  mounted: function () {
    window.addEventListener("deviceorientation", this.tiltQRCode,);
  },
  beforeDestroy: function () {
    window.addEventListener("deviceorientation", this.tiltQRCode);
  },
  methods: {
    tiltQRCode: function (event) {
      if (this.updateNow()) {
        let position = Math.round(event.gamma);
        if (Math.abs(position) > this.limit) {
          if (position > this.limit) {
            position = this.limit;
          } else {
            position = -this.limit;
          }
        }
        this.rotateY = position;
      }
    },
    updateNow: function () {
      return this.counter++ % this.updateRate === 0;
    }
  }
}
</script>
<style scoped>
.wrapper {
  background-image: linear-gradient(160deg, #0093E9 0%, #80D0C7 100%);
  position: relative;
  height: 100%;
}

.qr-container {
  position: absolute;
  left: 50%;
  top: 43%;
  transform: translate(-50%, -50%);
  transition: transform 0.5s;
  padding: 8px;
  width: 325px;
  height: 325px;
  -webkit-animation: borderAnimation 1.5s ease-in-out infinite alternate;
  animation: borderAnimation 1.5s ease-in-out infinite alternate;
  border-radius: 50%;
}

.qr-inner-container {
  place-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  place-content: center;
  display: flex;
}

.qr-inner-container label {
  -webkit-animation: imageAnimation 1.5s ease-in-out infinite alternate;
  animation: imageAnimation 1.5s ease-in-out infinite alternate;
  position: absolute;
  bottom: 35px;
}

.qr-code {
  width: 70%;
  height: 70%;
  align-self: center;
  -webkit-animation: imageAnimation 1.5s ease-in-out infinite alternate;
  animation: imageAnimation 1.5s ease-in-out infinite alternate;
}

.explore-more {
  position: absolute;
  left: 50%;
  top: 82%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 160px;
  font-size: 16px;
  font-weight: 600;
  height: 55px;
  border: none;
  border-radius: 50px;
  box-shadow: 0 5px 15px 0 rgb(209 210 213 / 88%);
}

@keyframes borderAnimation {
  0% {
    background-color: rgba(255, 255, 255, 0.199);
  }

  100% {
    background-color: rgba(255, 255, 255, 0.74);
  }
}

@keyframes imageAnimation {
  0% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1.0);
  }
}
</style>
